export const environment = {
  production: false,
  mapApiKey: 'AIzaSyCks2wRBdAusEVZ-32EoGpB96i3qg_SApg',
  baseUrl: 'https://api.dev.yumzy.ai/suggestionv2/v2/native',
  googleMapUrl: 'https://maps.googleapis.com',
  paymentBaseUrl :'https://common.laalsa.com/paymentco',
  paytmURL: "https://securegw-stage.paytm.in"
}

